import React, { Component } from 'react'
import { connect } from 'react-redux'
import store from '../../engine/store'
import { Bloc, BlocCredit } from '../ImportAll'

class ListingCredit extends Component {
    render() {
        const ajouterCredit = () => {
            let r = Math.random().toString(36).substring(7)
            store.dispatch({
                type: 'SET_MULTI',
                value: { key: 'credit_existants_list', value: r },
            })
            store.dispatch({
                type: 'SET',
                value: { key: 'credit_existants_duree_' + r, value: 12 },
            })
        }

        var listeCredits = this.props.listeCredit ? this.props.listeCredit : []

        const content = listeCredits.map((credit) => (
            <BlocCredit key={credit} id={credit} />
        ))
        return (
            <div>
                {content}
                <Bloc
                    selectable
                    nbcolumn={1}
                    simpleWord
                    text1="Ajouter un crédit"
                    customMethod={ajouterCredit}
                />
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        listeCredit: state.answer['credit_existants_list'],
    }
}

export default connect(mapStateToProps)(ListingCredit)
